import { Component, OnInit } from '@angular/core';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';
import {EntitlementService} from '../../services/entitlement.service';
import {CardholderService} from '../../services/cardholder.service';

@Component({
  selector: 'app-cardholder-profiles',
  templateUrl: './cardholder-profiles.component.html',
  styleUrls: ['./cardholder-profiles.component.css']
})
export class CardholderProfilesComponent implements OnInit {

  cardholder: ProfileSearchResult;

  constructor(private entitlementService: EntitlementService) { }

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

}
